module.exports = __webpack_public_path__ + "static/media/creator-01.d9c88b2b.png";